/**
 * AD password sync results (#251).
 *
 * Every endpoint that sets a password (reset, invite, set-password, user and
 * org create) pushes it to the user's Samba AD domains. A domain that refuses
 * keeps the old Windows (RDP) password; the portal has the new one either
 * way. The response then lists those domains in `ad_sync_errors`.
 */

/** One AD domain that kept the old password, and why. */
export interface AdSyncError {
  domain: string;
  error: string;
}

/** Carried by the response of every endpoint that sets a password. */
export interface AdSyncResult {
  ad_sync_errors?: AdSyncError[];
}

/**
 * The warning to show for a password change, or null when every AD domain
 * took the new password. Plain text, one domain per line.
 */
export function adSyncWarning(result: AdSyncResult | null | undefined): string | null {
  const errors = result?.ad_sync_errors;
  if (!errors || errors.length === 0) return null;
  const lines = errors.map((e) => `${e.domain}: ${e.error}`);
  return [
    'The portal password was changed, but Windows (RDP) sign-in still uses ' +
      'the old password on:',
    ...lines,
    'Signing in to the portal with the new password retries the sync.',
  ].join('\n');
}
